var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 25,
    viewBox: "0 0 15 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.945312 23.1602L13.4453 21.6602",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4219 0.0800781V1.68066H14.0254V2.63672H12.4219V4.24023H11.4658V2.63672H9.86523V1.68066H11.4658V0.0800781H12.4219Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79649 19.1602H0.445312L5.72829 4.16016H8.28734L13.5703 19.1602H11.2191L7.06874 6.88477H6.95405L2.79649 19.1602ZM3.19074 13.2861H10.8177V15.1904H3.19074V13.2861Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAPlus);
export default __webpack_public_path__ + "static/media/a-plus.86048436da342b8c71d811ddd34ecc0b.svg";
export { ForwardRef as ReactComponent };